// Phase 9 R3 — Release stock reservation via R1 RPC. Omitting qty releases full current reservation.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export function useReleaseInventoryReservation() {
  const { activeShop } = useAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      partsLineId,
      qty,
    }: {
      partsLineId: string;
      qty?: number;
      ticketId?: string;
      inventoryItemId?: string;
    }) => {
      const args: { p_parts_line_id: string; p_qty?: number } = {
        p_parts_line_id: partsLineId,
      };
      if (typeof qty === 'number') args.p_qty = qty;
      const { data, error } = await supabase.rpc('release_inventory_reservation', args);
      if (error) throw error;
      return data;
    },
    onSuccess: (_data, vars) => {
      const shopId = activeShop?.id;
      if (vars.ticketId) {
        qc.invalidateQueries({ queryKey: ['parts-lines', shopId, vars.ticketId] });
      }
      if (vars.inventoryItemId) {
        qc.invalidateQueries({ queryKey: ['inventory-item', shopId, vars.inventoryItemId] });
        qc.invalidateQueries({ queryKey: ['inventory-transactions', shopId, vars.inventoryItemId] });
      }
      qc.invalidateQueries({ queryKey: ['inventory-items', shopId] });
      toast.success('Reservation released');
    },
    onError: (e: any) => toast.error(e?.message ?? 'Release failed'),
  });
}
